import { BaseModel, propertyChangedArguments } from "../BaseModel";

export class EventStatusModel extends BaseModel {

    constructor(source?: EventStatusModel) {
        super();
        if (source != null) {
            this.copyIn(source);
        }
        else
        {
            this._eventStatusID = 0;
        }
    }

// private properties
    _eventStatusID: number = 0;
    _statusName: string = "";

// public properties
    public get eventStatusID(): number
    {
        return this._eventStatusID;
    }
    public set eventStatusID(v: number)
    {
        if (v !== this._eventStatusID)
        {
            this._eventStatusID = v;
            this.propertyChanged.emit(new propertyChangedArguments("eventStatusID", this));
        }
    }

    public get statusName(): string
    {
        return this._statusName;
    }
    public set statusName(v: string)
    {
        if (v !== this._statusName)
        {
            this._statusName = v;
            this.propertyChanged.emit(new propertyChangedArguments("statusName", this));
        }
    }


    override assignChildren(): void {
        super.assignChildren();
    }

    copyIn(source: EventStatusModel): void {
        if (source == null) return;
        this._eventStatusID = source.eventStatusID;
        this._statusName = source.statusName;
    }


}
